export default class CashFlowTransferDonation {

	constructor() {
		this.id = 0;
		this.cashFlowTransferId = 0;
		this.donationId = '';		
	}
}